<template>
  <div class="page">
    <div class="ctrl">共 {{ list.length }} 条</div>
    <a-table
      class="sec"
      size="small"
      :rowKey="(record) => record.id"
      bordered
      :columns="columns"
      :data-source="list"
      :pagination="false"
    >
      <template slot="headimgurl" slot-scope="text, record">
        <a-button
          style="margin-right: 10px"
          size="small"
          icon="mail"
          @click="sendMsg(record.who, record.nickname)"
        ></a-button>
        <img style="height: 32px" :src="record.headimgurl" alt="" />
        {{ record.nickname }}
      </template>

      <template slot="out_trade_no" slot-scope="text, record">
        <a-popconfirm
          :title="record.out_trade_no"
          ok-text="确认"
          cancel-text="关闭"
        >
          <a href="#">查看</a>
        </a-popconfirm>
      </template>

      <template slot="amount" slot-scope="text, record">
        <router-link :to="'/tuanpai/order/info?order_id=' + record.id">
          <a-button size="small">{{ record.amount }}</a-button>
        </router-link>
      </template>
      <template slot="status" slot-scope="text, record">
        <a-tag v-if="record.status == -1" color="red">已取消</a-tag>
        <a-tag v-if="record.status == 0" color="orange">未支付</a-tag>
        <a-tag v-if="record.status == 1" color="green">已支付</a-tag>
        <a-tag v-if="record.status == 2" color="orange">已发货</a-tag>
      </template>

      <template slot="action" slot-scope="text, record">
        <a-button
          type="primary"
          size="small"
          @click="
            fahuoModal.show = true;
            fahuoModal.order_id = record.id;
          "
          >发货</a-button
        >
        <a-popconfirm
          v-if="record.status == 0"
          title="确定将订单状态改为已支付吗？"
          ok-text="确定"
          cancel-text="取消"
          @confirm="pay(record.id)"
        >
          <a-button size="small"
            >付款</a-button
          >
        </a-popconfirm>
      </template>
    </a-table>

    <a-modal v-model="fahuoModal.show" title="发货" @ok="sub">
      <a-form :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
        <a-input v-model="fahuoModal.com" placeholder="快递公司"></a-input>
        <a-input
          style="margin: 10px 0"
          v-model="fahuoModal.sn"
          placeholder="快递单号"
        ></a-input>
        <a-textarea
          placeholder="请填写发货备注"
          v-model="fahuoModal.remarks"
          :auto-size="{ minRows: 4, maxRows: 6 }"
        />
      </a-form>
    </a-modal>

    <SendMsg :msg="msg" v-if="msg.show" @callback="cancelSend" />
  </div>
</template>

<style lang='scss' scoped>
</style>

<script>
const columns = [
  {
    title: "#",
    dataIndex: "id",
  },
  {
    title: "微信",
    scopedSlots: {
      customRender: "headimgurl",
    },
  },
  {
    title: "姓名",
    dataIndex: "name",
  },
  {
    title: "电话",
    dataIndex: "tel",
  },
  {
    title: "地址",
    dataIndex: "addr",
  },
  {
    title: "买家备注",
    dataIndex: "remarks",
  },
  {
    title: "订单商品",
    scopedSlots: {
      customRender: "amount",
    },
  },
  {
    title: "商品总价（元）",
    dataIndex: "money",
  },
  {
    title: "运费（元）",
    dataIndex: "fee",
  },
  {
    title: "合计（元）",
    dataIndex: "total",
  },
  {
    title: "快递公司",
    dataIndex: "fahuo_com",
  },
  {
    title: "快递单号",
    dataIndex: "fahuo_sn",
  },
  {
    title: "发货时间",
    dataIndex: "fahuo_at",
  },
  {
    title: "支付单号",
    scopedSlots: {
      customRender: "out_trade_no",
    },
  },
  {
    title: "下单时间",
    dataIndex: "created_at",
  },
  {
    title: "支付时间",
    dataIndex: "payed_at",
  },

  {
    title: "状态",
    scopedSlots: {
      customRender: "status",
    },
  },
  {
    title: "操作",
    scopedSlots: {
      customRender: "action",
    },
  },
];

import SendMsg from "../../../components/sendMsg.vue";

export default {
  components: { SendMsg },
  data() {
    return {
      auction_id: null,
      columns,
      list: [],
      fahuoModal: {
        show: false,
        order_id: null,
        remarks: "",
        com: "中通速运",
        sn: "",
      },
      msg: {
        show: false,
        who: "",
        nickname: "",
        content: "",
      },
    };
  },
  created() {
    this.auction_id = this.$route.query.auc_id;
    this.getList();
  },
  methods: {
    async getList() {
      const r = await this.$axios.get(
        "/tuanpai/order/getList?auction_id=" + this.auction_id
      );
      console.log(r);

      if (r.status == 1) this.list = r.list;
    },

    sendMsg(who, nickname) {
      this.msg = {
        show: true,
        who,
        nickname,
        content: "",
      };
    },

    cancelSend() {
      this.msg = {
        show: false,
        who: "",
        nickname: "",
      };
    },

    async sub() {
      const r = await this.$axios.post("/tuanpai/order/fahuo", this.fahuoModal);
      if (r.status == 1) {
        this.fahuoModal = {
          show: false,
          order_id: null,
          remarks: "",
          com: "中通速运",
          sn: "",
        };
        this.getList();
      }
    },

    async pay (id) {
      const r = await this.$axios.post('/tuanpai/pay', {
        id
      })

      if(r.status == 1) this.getList()
    }
  },
};
</script>